import map from 'lodash/map'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

const requiredFields = {
  phone: {
    title: 'Phone',
    rule: '',
  },
  terms: {
    title: 'Terms',
    rule: '',
  }
}

const validator = value => {
  const errors = {}

  map(requiredFields, ({ max, min, title }, field) => {
    if (field === 'terms') {
      if (!value[field]) errors[field] = 'You must agree to the terms and conditions and privary polici.'
    } else if (!value[field]) {
      errors[field] = `${title} field is required`
    } else if (value[field].length > max) {
      errors[field] = `Field reached ${max} characters`
    } else if (value[field].length < min) {
      errors[field] = `Field requires a minimum of ${min} characters`
    } else if (
      field === 'email' &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value[field])
    ) {
      errors[field] = `Invalid email format`
    } else if (field === 'phone') {
      const phoneNumber = parsePhoneNumberFromString(value[field])
      if (phoneNumber) {
        if (!phoneNumber.isValid()) {
          errors[field] = `Invalid phone format`
        }
      } else {
        errors[field] = `Invalid phone format`
      }
    }
  })

  return errors
}

export default validator
